import * as Api from '@ViewModels';
import { invalidateEmailAllCategoryTemplates } from '../EmailCampaign/useEmailAllCategoryTemplates';
import { invalidateEmailCategoryTemplates } from '../EmailCampaign/useEmailCategoryTemplates';
import { invalidateEmailSearchTemplates } from '../EmailCampaign/useEmailSearchTemplates';
import { invalidateAllMyTemplatesFilter } from './useMyTemplatesFilter';
import { invalidateAllMyTemplatesFilterInfinite } from './useMyTemplatesFilterInfiniteQuery';
import { invalidateMyTemplates } from './useMyTemplatesQuery';
import { updateCachedTemplate } from './useTemplate';

/** The lists behind the email template cards, whose server-rendered previewHtml goes stale when a template changes */
export const invalidateEmailTemplateLists = () => {
	invalidateEmailAllCategoryTemplates();
	invalidateEmailCategoryTemplates();
	invalidateEmailSearchTemplates();
	invalidateMyTemplates({ templateType: Api.TemplateType.Email });
	invalidateAllMyTemplatesFilter();
	invalidateAllMyTemplatesFilterInfinite();
};

export function refreshSavedTemplateQueries(
	template: Api.ITemplate,
	{ invalidateTemplateLists = true }: { invalidateTemplateLists?: boolean } = {}
) {
	updateCachedTemplate(template);
	if (invalidateTemplateLists && template?.templateType === Api.TemplateType.Email) {
		invalidateEmailTemplateLists();
	}
}
